import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SessionTokenStorage } from './storage/SessionTokenStorage';
export class TokenClient {
  constructor(options) {
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "storage", void 0);
    _defineProperty(this, "requestOptions", void 0);
    _defineProperty(this, "timeout", null);
    _defineProperty(this, "isTimeoutSet", false);
    _defineProperty(this, "tokenData", null);
    _defineProperty(this, "tokenRequest", null);
    this.options = options;
    this.storage = this.options.storage ?? new SessionTokenStorage();
    this.requestOptions = TokenClient.createRequestOptions(this.options.requestOptions);
  }
  static createRequestOptions(requestOptions) {
    if (!requestOptions) {
      return TokenClient.REQUEST_OPTIONS;
    }
    return {
      ...TokenClient.REQUEST_OPTIONS,
      ...requestOptions
    };
  }
  bindTokenUpdated(handler) {
    document.addEventListener(TokenClient.TOKEN_UPDATED_EVENT, handler);
    return this;
  }
  unbindTokenUpdated(handler) {
    document.removeEventListener(TokenClient.TOKEN_UPDATED_EVENT, handler);
    return this;
  }
  async getToken() {
    const isTokenRefreshed = await this.refreshToken();
    return isTokenRefreshed ? this.tokenData : null;
  }
  async refreshToken() {
    if (!this.tokenData) {
      this.tokenData = this.storage.token.get();
    }
    const isTokenValid = !!this.tokenData && !this.hasTokenExpired(this.tokenData);
    if (!isTokenValid) {
      if (this.tokenData) {
        this.removeTokenFromStorage();
      }
      const tokenData = await this.requestToken();
      this.saveTokenToStorage(tokenData);
      const event = new CustomEvent(TokenClient.TOKEN_UPDATED_EVENT, {
        detail: {
          tokenData: this.tokenData
        }
      });
      document.dispatchEvent(event);
    }
    this.setRefreshTimeout(this.tokenData);
    return true;
  }
  async requestToken() {
    try {
      if (!this.tokenRequest) {
        this.tokenRequest = fetch(this.options.url, this.requestOptions);
      }
      const response = await this.tokenRequest;
      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }
      const result = response.json();
      return result;
    } catch (error) {
      throw new Error(`Token request has failed: ${error}`);
    }
  }
  setRefreshTimeout(tokenData) {
    if (this.isTimeoutSet || !tokenData) {
      return;
    }
    this.isTimeoutSet = true;
    if (this.timeout !== null) {
      window.clearTimeout(this.timeout);
    }
    this.timeout = window.setTimeout(() => {
      this.isTimeoutSet = false;
      this.tokenRequest = null;
      void this.refreshToken();
    }, this.getTokenRefreshTime(tokenData));
  }
  removeTokenFromStorage() {
    this.tokenData = null;
    this.storage.token.remove();
  }
  saveTokenToStorage(tokenData) {
    this.tokenData = tokenData;
    this.storage.token.set(tokenData);
  }
  getTokenRefreshTime(tokenData) {
    const expirationDate = Date.parse(tokenData.ExpirationDate);
    const currentDate = Date.now();
    let timeToRefresh = expirationDate - currentDate;
    if (timeToRefresh <= TokenClient.TOKEN_REQUEST_INTERVAL) {
      timeToRefresh = 0;
    }
    return timeToRefresh;
  }
  hasTokenExpired(tokenData) {
    const expirationDate = Date.parse(tokenData.ExpirationDate);
    return expirationDate <= Date.now();
  }
}
_defineProperty(TokenClient, "REQUEST_OPTIONS", {
  credentials: 'same-origin',
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Fetch-Api': '1',
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Requested-With': 'XMLHttpRequest'
  },
  method: 'POST'
});
_defineProperty(TokenClient, "TOKEN_REQUEST_INTERVAL", 30000);
_defineProperty(TokenClient, "TOKEN_UPDATED_EVENT", 'tokenUpdated');
//# sourceMappingURL=TokenClient.js.map